<template>
    <div>
        <modal @closed="close"
               cancel-button-text="OK"
               class="text-center"
               custom-class="max-w-md"
               :showOldCloseBtn="false">
               <p v-text="$t('RATE_FLOWERS_FILE_TOO_LARGE')"></p>
        </modal>
    </div>
</template>

<script>
import Modal from '@/components/structure/Modal';

export default {
    name: 'AlertModal',
    methods: {
        close() {
            this.$emit('closed');
        },
    },
    components: {
        Modal,
    },
};
</script>

<style scoped>
    .btn {
        font-weight: 400;
        font-family: gillsans;
        padding: 0.5rem 2rem 0.5rem 2rem;
        display: inline-block;
        border-radius: 0.25rem;
        min-width: 300px;
        max-height: 50px;
        color: #fff;
        background-color: #5AB5D9;
        border-color: #5AB5D9;
        margin-top: 1rem;
    }

</style>
